import React from 'react';
import NewsletterSignup from '../../common/Newsletter';

const FooterNewsletter: React.FC = () => (
  <div className="w-full flex flex-col justify-center items-center text-center">
    <p className="text-maroon font-prosto pb-2">
      Subscribe for updates and special offers
    </p>
    <NewsletterSignup />
  </div>
);

export default FooterNewsletter;
